<template>
  <div class="OfficeTimekeeping">
    <CCard title="Tìm kiếm" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <span class="card-header-title">Văn phòng tổng hợp chấm công</span>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow>
          <CCol sm="3">
            <CSelect
              label="Đơn vị"
              :options="dataDepartment"
              :value.sync="valueDepartment"
              @change="changDepartment"
            />
          </CCol>
          <CCol sm="3">
            <CSelect
              label="Năm"
              :options="dataYear"
              :value.sync="valueYear"
              @change="searchTK"
            />
          </CCol>
          <CCol sm="3">
            <CSelect
              label="Tháng"
              :options="dataMonth"
              :value.sync="valueMonth"
              @change="searchTK"
            />
          </CCol>
          <CCol sm="3">
            <CSelect
              label="Trạng thái"
              :options="dataTT"
              :value.sync="valueTT"
              @change="searchTK"
            />
          </CCol>
        </CRow>
        <CRow style="margin-top:10px">
          <CCol sm="3" />
          <CCol sm="6" class="center">
            <vs-button
              warn
              square
              class="custom_btn_search float-left"
              @click="searchTK()"
            >
              <i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
            >
          </CCol>
          <CCol sm="3" />
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mb-2">
      <vue-good-table
        :columns="columns"
        :rows="dataTK"
        compactMode
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          nextLabel: 'Trang sau',
          prevLabel: 'Trang trước',
          ofLabel: 'của',
          perPage: 100,
        }"
        :line-numbers="true"
        :search-options="{
          enabled: false,
          placeholder: 'Tìm kiếm',
        }"
        :sort-options="{
          enabled: false,
        }"
      >
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'action'">
            <div v-if="props.row.status == 1" class="row center">
              <vs-tooltip color="danger">
                <template #tooltip>
                  Trả lại để lãnh đạo phê duyệt lại.
                </template>
                <vs-button
                  @click="CancelCensorship(props.row)"
                  danger
                  square
                  size="mini"
                >Trả lại</vs-button>
              </vs-tooltip>
            </div>
          </div>
          <div v-else-if="props.column.field === 'status'">
            <CBadge v-if="props.row.lock == 1" color="success">Đã khoá</CBadge>
            <CBadge
              v-if="props.row.status == 1 && props.row.lock != 1"
              color="primary"
              >Đã duyệt</CBadge
            >
            <CBadge
              v-else-if="props.row.status == -1 && props.row.lock != 1"
              color="warning"
              >Chờ duyệt</CBadge
            >
            <CBadge
              v-else-if="props.row.status == 2 && props.row.lock != 1"
              color="secondary"
              >Chưa nộp</CBadge
            >
            <CBadge
              v-else-if="props.row.status == 3 && props.row.lock != 1"
              color="danger"
              >Từ chối</CBadge
            >
            <CBadge
              v-if="props.row.status == 5 && props.row.lock != 1"
              color="danger"
              >Văn phòng trả</CBadge
            >
            <CBadge
              v-if="props.row.status == 6 && props.row.lock != 1"
              color="success"
              >Gửi văn phòng</CBadge
            >
          </div>
        </template>
      </vue-good-table>
      <CRow>
        <CCol sm="12" class="center" style="margin-top:10px">
          <vs-button success square @click="downloadTimeSheet()">
            <i class="bx bxs-download"></i>&nbsp;Tải về</vs-button
          >
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from "vue-good-table";
const timekeepingApi = ClientFactory.get("timekeepings");
const dropdownsApi = ClientFactory.get("dropdowns");
const departmentApi = ClientFactory.get("departments");

export default {
  components: {
    VueGoodTable,
  },
  data: () => ({
    valueDepartment: "0",
    dataDepartment: [],
    dataTK: [],
    valueMonth: new Date().getMonth() + 1,
    valueYear: new Date().getFullYear(),
    dataYear: [
      {
        label: new Date().getFullYear() + 1,
        value: new Date().getFullYear() + 1,
      },
      {
        label: new Date().getFullYear(),
        value: new Date().getFullYear(),
      },
      {
        label: new Date().getFullYear() - 1,
        value: new Date().getFullYear() - 1,
      },
      {
        label: new Date().getFullYear() - 2,
        value: new Date().getFullYear() - 2,
      },
    ],
    valueTT: "1",
  }),
  async created() {
    await this.GetDepartment();
    // Lấy trạng thái có trong store, dùng để trở lại trạng thái search trước khi sau khi từ màn hình phê duyệt/chi tiết trở về
    ({
      department_id: this.valueDepartment,
      year: this.valueYear,
      month: this.valueMonth,
      status: this.status,
    } = this.filterDTK);

    this.searchTK();
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    ...mapActions("TimeKeepingStore", ["saveDepartmentSearchFilter"]),
    async GetDepartment() {
      this.dataDepartment = await dropdownsApi.get(
        dropdownsApi.type.DEPARTMENTS
      );

      // const params = {
      //   department_type: 1,
      // };

      // const result = await departmentApi.get_department_byuser(params);
      // if (result.status == "success") {
      //   this.dataDepartment = await this.MapSelect(result.data, "name", "id");
      // } else {
      //   this.dataDepartment = [];
      // }
    },
    async MapSelect(data, label_data, value_data) {
      let result = [];
      let dt = {};
      dt.label = "Tất cả";
      dt.value = "0";
      result.push(dt);
      for (let index = 0; index < data.length; index++) {
        dt = {};
        dt.label = data[index][label_data];
        dt.value = data[index][value_data];
        result.push(dt);
      }

      return result;
    },

    searchTK: async function() {
      this.loading(this.$vs);
      const params = {
        year: this.valueYear,
        month: this.valueMonth,
        status: this.valueTT,
        department_id: this.valueDepartment,
      };
      // save search filter to global store to keep state filter when come back.
      this.saveDepartmentSearchFilter({
        filter: params,
      });

      // call seach API.
      const result = await timekeepingApi.get_office_summary_tk(params);

      this.checkResponseData(result);
    },
    checkResponseData: function(data) {
      if (data.status == "success") {
        this.dataTK = data.data;
      } else {
        this.dataTK = [];
      }
      this.closeLoading();
    },
    async changDepartment() {
      this.searchTK();
    },
    /**
     * Tải bản chấm công (excel)
     */
    downloadTimeSheet: async function() {
      this.loading(this.$vs);
      const params = {
        year: this.valueYear,
        month: this.valueMonth,
        status: this.valueTT,
        department_id: this.valueDepartment,
      };

      const response = await timekeepingApi.report_office_summary_tk(params);
      this.closeLoading();

      if (typeof response === "undefined" || response.status === "failed") {
        return this.notify({
          error: true,
          text: response.message || "Unknow error",
        });
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Bao_cao_ngay_cong_${+new Date().getTime()}.xlsx`
      );
      link.click();
      window.URL.revokeObjectURL(url);
    },
    CancelCensorship: async function(item) {
      ///// Trả lại bảng chấm công
      // console.log(item);
      // return;

      let body = {};
      body.employee_id = item.employee_id;
      body.year = item.year;
      body.month = item.month;
      body.session = 0;
      body.approve = 5;

      const result = await timekeepingApi.censorship_timekeeping(body);

      if (result.status == "success") {
        this.notify({ text: result.data[0].error_message });
        this.searchTK();
        this.closeLoading();
      } else {
        this.notify({ error: true, text: result.message });
        this.searchTK();
        this.closeLoading();
      }
    },
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
    ...mapGetters("TimeKeepingStore", ["filterDTK"]),
    columns() {
      return [
        {
          label: "ID",
          field: "id",
          hidden: true,
        },
        {
          label: "Tháng",
          field: "monthyear",
          thClass: "tk-month-class text-center",
          tdClass: "tk-month-class text-center",
        },
        {
          label: "Họ và tên ",
          field: "full_name",
          width: "190px",
          thClass: "",
        },
        {
          label: "Trạng thái",
          field: "status",
          sortable: false,
          width: "90px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Thao tác",
          field: "action",
          sortable: false,
          width: "90px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "N.Công",
          field: "workday_real",
          width: "90px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "1 ",
          field: "timesheet.d1",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },

        {
          label: "2 ",
          field: "timesheet.d2",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },

        {
          label: "3 ",
          field: "timesheet.d3",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },

        {
          label: "4 ",
          field: "timesheet.d4",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },

        {
          label: "5 ",
          field: "timesheet.d5",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },

        {
          label: "6 ",
          field: "timesheet.d6",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },

        {
          label: "7 ",
          field: "timesheet.d7",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },

        {
          label: "8",
          field: "timesheet.d8",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "9",
          field: "timesheet.d9",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "10",
          field: "timesheet.d10",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "11",
          field: "timesheet.d11",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "12",
          field: "timesheet.d12",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "13",
          field: "timesheet.d13",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "14",
          field: "timesheet.d14",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "15",
          field: "timesheet.d15",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "16",
          field: "timesheet.d16",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "17",
          field: "timesheet.d17",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "18",
          field: "timesheet.d18",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "19",
          field: "timesheet.d19",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "20",
          field: "timesheet.d20",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "21",
          field: "timesheet.d21",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "22",
          field: "timesheet.d22",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "23",
          field: "timesheet.d23",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "24",
          field: "timesheet.d24",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "25",
          field: "timesheet.d25",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "26",
          field: "timesheet.d26",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "27",
          field: "timesheet.d27",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "28",
          field: "timesheet.d28",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "29",
          field: "timesheet.d29",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "30",
          field: "timesheet.d30",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
        {
          label: "31",
          field: "timesheet.d31",
          thClass: "tk-width-class",
          tdClass: "tk-width-class",
        },
      ];
    },
    dataMonth() {
      return [
        {
          label: "Tháng 1",
          value: 1,
        },
        {
          label: "Tháng 2",
          value: 2,
        },
        {
          label: "Tháng 3",
          value: 3,
        },
        {
          label: "Tháng 4",
          value: 4,
        },
        {
          label: "Tháng 5",
          value: 5,
        },
        {
          label: "Tháng 6",
          value: 6,
        },
        {
          label: "Tháng 7",
          value: 7,
        },
        {
          label: "Tháng 8",
          value: 8,
        },
        {
          label: "Tháng 9",
          value: 9,
        },
        {
          label: "Tháng 10",
          value: 10,
        },
        {
          label: "Tháng 11",
          value: 11,
        },
        {
          label: "Tháng 12",
          value: 12,
        },
      ];
    },
    dataTT() {
      return [
        {
          label: "Tất cả",
          value: "0",
        },
        // {
        //   label: "Gửi văn phòng",
        //   value: "6",
        // },
        {
          label: "Văn phòng trả",
          value: "5",
        },
        {
          label: "Chờ duyệt",
          value: "-1",
        },
        {
          label: "Đã duyệt",
          value: "1",
        },
        {
          label: "Chưa nộp",
          value: "2",
        },
        // {
        //   label: "Trả lại",
        //   value: "3",
        // }
      ];
    },
  },
  destroyed() {
    this.closeLoading();
  },
};
</script>

<style lang="scss">
.OfficeTimekeeping {
  table.vgt-table td {
    vertical-align: inherit;
    padding: 0em 0.75em 0em 0.75em;
  }
  .tk-width-class {
    min-width: 10px !important;
    text-align: center;
  }
  .tk-name-class {
    min-width: none;
    -width: 250px !important;
  }

  .tk-month-class {
    min-width: none;
    -width: 80px !important;
  }

  .visible {
    visibility: visible !important;
  }
  .invisible {
    visibility: hidden !important;
  }
  .tk-status-class {
    min-width: 100px;
    text-align: center;
  }
  .tk-action-class {
    min-width: 150px;
    text-align: center;
  }
}
</style>
